import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import useConfirmStore from '../hooks/useConfirm';

const GlobalConfirmModal = () => {
  const { darkMode } = useTheme();
  const { isOpen, title, message, onConfirm, type, confirmText, cancelText, closeConfirm } = useConfirmStore();

  if (!isOpen) return null;

  const typeColors = {
    danger: 'bg-red-600 hover:bg-red-700',
    warning: 'bg-yellow-600 hover:bg-yellow-700',
    info: 'bg-brand hover:bg-brand',
  };

  const iconColors = {
    danger: 'bg-red-100 text-red-600',
    warning: 'bg-yellow-100 text-yellow-600',
    info: 'bg-brand-soft text-brand',
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black bg-opacity-50" onClick={closeConfirm}>
      <div 
        className={`relative w-full max-w-md rounded-lg shadow-xl ${'bg-surface'}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${iconColors[type]}`}>
              <AlertTriangle className="h-6 w-6" />
            </div>
            <div className="flex-1">
              <h3 className={`text-lg font-semibold mb-2 ${'text-text'}`}>
                {title}
              </h3>
              <p className={`text-sm ${'text-dim'}`}>
                {message}
              </p>
            </div>
            <button
              onClick={closeConfirm}
              className={`flex-shrink-0 ${'text-dim hover:text-text'}`}
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
        
        <div className={`flex gap-3 px-6 py-4 ${'bg-bg'} rounded-b-lg`}>
          <button
            onClick={closeConfirm}
            className={`flex-1 px-4 py-2 rounded-lg font-medium transition-colors ${
              'bg-surface-2 text-text hover:bg-surface-3'
            }`}
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              closeConfirm();
            }}
            className={`flex-1 px-4 py-2 rounded-lg font-medium text-white transition-colors ${typeColors[type]}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalConfirmModal;
